const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)



export default [
    {
        path: '/orders',
        component: {
            template: '<div class="content-wrapper"><router-view></router-view></div>'
        },
        name: 'Orders',
        meta: {
            showInMenu: true,
            title: 'Заказы',
            menuKey: 'Orders',
            roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        },
        redirect: 'orders',
        children: [
            {
                path: '',
                component: _import('orders/components/list'),
                name: 'Orders.list',
                meta: {
                    menuKey: 'Orders',
                    roles: ['ROLE_ADMIN', 'ROLE_WAITER']
                }
            },
            {
                path: 'edit/:id',
                component: _import('orders/components/edit'),
                name: 'Orders.edit',
                meta: {
                    menuKey: 'Orders',
                    roles: ['ROLE_ADMIN', 'ROLE_WAITER']
                }
            },
            {
                path: ':id',
                component: _import('orders/components/info'),
                name: 'Orders.info',
                meta: {
                    menuKey: 'Orders',
                    roles: ['ROLE_ADMIN', 'ROLE_WAITER']
                }
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/modules/orders/routes.js